/**
 * The competition-snapshot edge function replies via successResponse(), which
 * wraps its payload one level deep: { success: true, data: { submissionId, snapshotId } }.
 * See Lantern.Firebase/supabase/functions/_shared/cors.ts.
 */
export function extractSubmissionId(payload: unknown): string | null {
	if (typeof payload !== 'object' || payload === null) return null;
	const data = (payload as { data?: unknown }).data;
	if (typeof data !== 'object' || data === null) return null;
	const submissionId = (data as { submissionId?: unknown }).submissionId;
	return typeof submissionId === 'string' ? submissionId : null;
}
